import React, { useState } from 'react';
import PricingTable from '.';
import Section from '../Div';
import Spacing from '../Spacing';

export default function PricingTableList() {
    const [tab, setTab] = useState('monthly');
    const [includeVAT, setIncludeVAT] = useState(false);

    // Function to calculate VAT-inclusive price
    const calculatePriceWithVAT = (price) => {
        return includeVAT ? (price * 1.21).toFixed(2) : price.toFixed(2);
    };

    return (
        <Section className="position-relative">
            {/* VAT Toggle Switch */}
            <div className="container text-center">
                <label className="cs-font_18">
                    <input
                        type="checkbox"
                        checked={includeVAT}
                        onChange={() => setIncludeVAT(!includeVAT)}
                    />
                    {' '} Show prices including VAT (21%)
                </label>
            </div>

            <Spacing lg='25' md='25'/>

            {/* Monthly & Yearly Tab Switch */}
            <ul className="cs-tab_links cs-style1 cs-mp0 cs-primary_font text-center">
                <li className={tab === 'monthly' ? "active" : ""} onClick={() => setTab('monthly')}>Monthly</li>
                <li className={tab === 'yearly' ? "active" : ""} onClick={() => setTab('yearly')}>Yearly</li>
            </ul>

            <Section className="row">
                <Section className="col-lg-4">
                    <PricingTable
                        title='Essential AI'
                        price={calculatePriceWithVAT(tab === 'monthly' ? 349 : 2790)}
                        currency='€'
                        timeline={tab === 'monthly' ? 'monthly' : 'yearly'}
                        features={[
                            'AI-optimized responsive design',
                            'Conversion-focused SEO setup',
                            'Premium hosting & security',
                            'Monthly performance analytics',
                            'Basic AI chatbot integration',
                            'Email marketing automation',
                        ]}
                        btnText='Elevate Your Business'
                        btnLink={tab === 'monthly' ? 'https://buy.stripe.com/14k5mx9pM4mWeZ25kq' : 'https://buy.stripe.com/5kAdT37hE8DcbMQbIP'}
                        vatIncluded={includeVAT}
                    />
                    <Spacing lg='25' md='25'/>
                </Section>

                <Section className="col-lg-4">
                    <PricingTable
                        title='Business Accelerator'
                        price={calculatePriceWithVAT(tab === 'monthly' ? 649 : 5190)}
                        currency='€'
                        timeline={tab === 'monthly' ? 'monthly' : 'yearly'}
                        features={[
                            'Custom high-conversion design',
                            'Advanced SEO & content strategy',
                            'Real-time analytics dashboard',
                            'Advanced AI chatbot with training',
                            'CRM integration & automation',
                            '10 custom workflow automations',
                            'Priority 24-hour support',
                        ]}
                        btnText='Scale Your Business'
                        btnLink={tab === 'monthly' ? 'https://buy.stripe.com/4gw7uF9pM2eO7wA9AI' : 'https://buy.stripe.com/aEUcOZ9pMcTs4ko5kt'}
                        vatIncluded={includeVAT}
                    />
                    <Spacing lg='25' md='25'/>
                </Section>

                <Section className="col-lg-4">
                    <PricingTable
                        title='Enterprise Suite'
                        price={calculatePriceWithVAT(tab === 'monthly' ? 1299 : 9990)}
                        currency='€'
                        timeline={tab === 'monthly' ? 'monthly' : 'yearly'}
                        features={[
                            'Enterprise-grade architecture',
                            'Full marketing automation suite',
                            'AI-driven personalization engine',
                            'Predictive analytics & insights',
                            'Multi-channel integration',
                            'Unlimited workflow automations',
                            'Dedicated success manager',
                            'Enterprise 24/7 priority support',
                        ]}
                        btnText='Transform Your Enterprise'
                        btnLink={tab === 'monthly' ? 'https://buy.stripe.com/bIY9CN59wbPoaIM14e' : 'https://buy.stripe.com/bIYdT3gSeg5E6swfZd'}
                        vatIncluded={includeVAT}
                    />
                    <Spacing lg='25' md='25'/>
                </Section>

                <div className="container text-center cs-heading_wrapper">
                    <h2 className="cs-section_heading">Performance-Based Solutions</h2>
                    <p className="cs-font_22 cs-m0">Zero upfront hosting costs. You only pay when we deliver results.</p>
                    <Spacing lg='50' md='30'/>
                </div>

                <Section className="col-lg-4">
                    <PricingTable
                        title='Growth Partner'
                        price={calculatePriceWithVAT(4900)}
                        currency='€'
                        timeline='Setup + Revenue Share'
                        features={[
                            'Custom AI-optimized website',
                            'Conversion-focused design & UX',
                            'Advanced SEO & content strategy',
                            'Automated lead nurturing system',
                            'FREE hosting & maintenance',
                            'Only 5% of new revenue generated',
                            '90-day guarantee or money back',
                        ]}
                        btnText='Partner With Us'
                        btnLink='https://buy.stripe.com/aEU02dbxU5r05osdR2'
                        vatIncluded={includeVAT}
                        isPerformanceBased={true}
                    />
                    <Spacing lg='25' md='25'/>
                </Section>

                <Section className="col-lg-4">
                    <PricingTable
                        title='Business Transformer'
                        price={calculatePriceWithVAT(12900)}
                        currency='€'
                        timeline='Setup + Revenue Share'
                        features={[
                            'Enterprise-grade custom platform',
                            'Full e-commerce/service automation',
                            'AI-driven customer experience',
                            'Conversion rate optimization',
                            'FREE hosting & premium security',
                            'Only 3% of new revenue generated',
                            'Dedicated business strategist',
                            '180-day guarantee or money back',
                        ]}
                        btnText='Transform Your Business'
                        btnLink='https://buy.stripe.com/dR6aGRdG26v49EI28l'
                        vatIncluded={includeVAT}
                        isPerformanceBased={true}
                    />
                    <Spacing lg='25' md='25'/>
                </Section>

                <Section className="col-lg-4">
                    <PricingTable
                        title='Enterprise Accelerator'
                        price={calculatePriceWithVAT(39900)}
                        currency='€'
                        timeline='Setup + Revenue Share'
                        features={[
                            'Fully custom enterprise solution',
                            'Proprietary AI optimization engine',
                            'Complete business automation',
                            'Multi-channel customer experience',
                            'FREE enterprise hosting & security',
                            'Only 3% of new revenue generated',
                            'Dedicated executive team',
                            '365-day guarantee or money back',
                        ]}
                        btnText='Accelerate Your Enterprise'
                        btnLink='https://buy.stripe.com/4gw02d8lIf1A4ko28m'
                        vatIncluded={includeVAT}
                        isPerformanceBased={true}
                    />
                    <Spacing lg='25' md='25'/>
                </Section>
            </Section>

            <div className="container text-center cs-tagline">
                <Spacing lg='50' md='30'/>
                <p className="cs-font_18">Focus on what you do best. Let ACE handle your entire online presence.</p>
                <p className="cs-font_18 cs-m0">All Performance-Based plans include quarterly business reviews and strategy sessions.</p>
            </div>
        </Section>
    );
}